import { app_domain } from 'app/config/constants'
import { i18n } from 'i18n'
import { Footer, Product } from 'type/Product'

function fixFooter(raw: Footer | boolean | undefined): Footer {
  if (raw == null || raw === true) return {}
  if (raw === false) return { on: false }
  return raw
}

function getTitle() {
  const atelier = app_domain === 'atelier'
  if (atelier) return 'ATELIERDIGITAL.AI'
  const dresscode = app_domain === 'dresscode'
  return dresscode ? 'DRESSCODE AI' : 'SHOWOFF'
}

function getLink() {
  const atelier = app_domain === 'atelier'
  if (atelier) return 'https://atelierdigital.ai/'
  const dresscode = app_domain === 'dresscode'
  return dresscode ? 'https://www.dresscode.ai/' : 'https://www.showoff.app/'

}

export class PoweredOptions {
  readonly on: boolean
  private readonly _powered: string | undefined
  private readonly _by: string | undefined
  private readonly _url: string | undefined

  static fromProduct(product: Product | undefined): PoweredOptions {
    const footer = fixFooter(product?.footer)
    return new PoweredOptions(footer)
  }

  constructor(json: Footer) {
    const { on, custom, powered, by, url } = json
    this.on = on !== false
    if (custom) {
      this._powered = powered?.trim() || undefined
      this._by = by?.trim() || undefined
      this._url = url?.trim() || undefined
    }
  }

  get powered(): string {
    return this._powered || i18n('PoweredBy')
  }

  get by(): string {
    return this._by || getTitle()
  }

  get url(): string {
    return this._url || getLink()
  }
}
